export enum EntryPoint {
  BaseReceived = 'baseReceived',
  First = 'first',
}
